export const validateEnvironmentVariables = (args: {
  environmentVariables: string;
  keyValueFormatError: string;
}): string | undefined => {
  const variables = args.environmentVariables.split('\n');
  for (const variable of variables) {
    const [key, value] = variable.split('=');
    if (!key || !value) {
      return args.keyValueFormatError;
    }
  }
  return undefined;
};
